import request from "../../Request";
import {rThen} from "../../requestThen";

export let getPlayerStatsTutor = async (id) => {

  return request.get(`/api/olymp/get_players_stats_pedagog/${id}`, true).then(r => {
    return rThen(r);
  })
}